var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrganisations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#757575",
  clipPath: "url(#organisations_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 11v10h6v-5h2v5h6V11L8 6zm12 8h-2v-5H5v5H3v-6.97l5-3.57 5 3.57zM19 7h-2v2h2zM19 11h-2v2h2zM19 15h-2v2h2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 3v1.97l2 1.43V5h9v14h-4v2h6V3z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "organisations_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export { SvgOrganisations as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQwOTZfMzk0KSI+CjxwYXRoIGQ9Ik0xIDExVjIxSDdWMTZIOVYyMUgxNVYxMUw4IDZMMSAxMVpNMTMgMTlIMTFWMTRINVYxOUgzVjEyLjAzTDggOC40NkwxMyAxMi4wM1YxOVoiIGZpbGw9IiM3NTc1NzUiLz4KPHBhdGggZD0iTTE5IDdIMTdWOUgxOVY3WiIgZmlsbD0iIzc1NzU3NSIvPgo8cGF0aCBkPSJNMTkgMTFIMTdWMTNIMTlWMTFaIiBmaWxsPSIjNzU3NTc1Ii8+CjxwYXRoIGQ9Ik0xOSAxNUgxN1YxN0gxOVYxNVoiIGZpbGw9IiM3NTc1NzUiLz4KPHBhdGggZD0iTTEwIDNWNC45N0wxMiA2LjRWNUgyMVYxOUgxN1YyMUgyM1YzSDEwWiIgZmlsbD0iIzc1NzU3NSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzQwOTZfMzk0Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";